import React, { Fragment } from 'react';
import classnames from 'classnames';

import { HtmlSanitizer } from '@BICE_Vida/scp-components';

import Text from '../../designSystem/Text';

import styles from './AvailablePlanCard.module.scss';

import { availablePlanCard } from '../../utils/generalTexts';

type AvailablePlanCardCoverageT = {
  cardCoverages: string[];
  discount: boolean;
  brandingCode?: string;
};

const AvailablePlanCardCoverage = ({
  cardCoverages,
  discount,
  brandingCode,
}: AvailablePlanCardCoverageT) => {
  const coverageSectionTitleClasses = classnames(
    styles.title_text,
    styles.coverage_section_title,
    discount ? styles.withDiscount : styles.withoutDiscount
  );

  const coverage = brandingCode && availablePlanCard.coverages(brandingCode);

  return (
    <Fragment>
      <Text
        text={availablePlanCard.coveragesTitle(brandingCode)}
        customClass={coverageSectionTitleClasses}
      />
      {!!cardCoverages?.length &&
        cardCoverages.map((value) => {
          return (
            <div className={styles.coverage_details_group} key={value}>
              <span className={styles.coverage_check} />
              <HtmlSanitizer
                className={styles.modal_message}
                html={value}
                tag="span"
                allowedTags={['b']}
              />
            </div>
          );
        })}

      {coverage && (
        <div className={styles.branding_plan_fist}>
          <div className={styles.exclusive_benefits_fist}>
            <Text
              customClass={styles.exclusive_benefits_fist_title}
              text={coverage.exclusive.title}
            />
            <Text
              customClass={styles.exclusive_benefits_fist_description}
              text={coverage.exclusive.description}
            />
          </div>
          <div className={styles.optional_coverages_fist}>{coverage.optional}</div>
        </div>
      )}

      {!coverage && (
        <div className={styles.optional_text}>
          <strong>{availablePlanCard.optionalTitle}</strong>
          <div>{availablePlanCard.optional}</div>
        </div>
      )}
    </Fragment>
  );
};

export default AvailablePlanCardCoverage;
